import { Controller } from "@hotwired/stimulus"

// Keeps the builder's live preview in step: reloads the preview iframe after
// any successful save on the page, keeping the visitor's scroll position.
// The frame is aria-busy while it reloads, so assistive tech (and specs) know
// its document is about to be replaced.
export default class extends Controller {
  static targets = ["frame"]

  refresh(event) {
    if (!event.detail.success) return

    const frame = this.frameTarget
    const scrollY = frame.contentWindow?.scrollY || 0
    frame.setAttribute("aria-busy", "true")
    frame.addEventListener("load", () => {
      frame.removeAttribute("aria-busy")
      frame.contentWindow?.scrollTo(0, scrollY)
    }, { once: true })
    frame.contentWindow?.location.reload()
  }
}
